<template>
  <footer class="customer-dashboard-footer">
    <div class="footer-inner">
      <div class="footer-copyright">
        © {{ currentYear }} Nexgbits. All rights reserved.
      </div>

      <div class="footer-links">
        <router-link
          to="/privacy"
          class="footer-link"
        >
          Privacy Policy
        </router-link>

        <span>
          •
        </span>

        <router-link
          to="/terms"
          class="footer-link"
        >
          Terms of Service
        </router-link>

        <span>
          •
        </span>

        <router-link
          to="/help"
          class="footer-link"
        >
          Help Center
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script setup>
import {
  computed
} from "vue"

const currentYear =
  computed(() =>
    new Date()
      .getFullYear()
  )
</script>

<style scoped>
.customer-dashboard-footer {
  width:
    100%;

  background:
    #ffffff;

  border-top:
    1px solid
    rgba(
      15,
      23,
      42,
      0.06
    );
}

.footer-inner {
  width:
    100%;

  max-width:
    1700px;

  min-height:
    68px;

  margin:
    0 auto;

  padding:
    0 30px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    space-between;

  gap:
    20px;

  color:
    #707894;

  font-size:
    11px;
}

.footer-links {
  display:
    flex;

  align-items:
    center;

  gap:
    12px;
}

.footer-link {
  color:
    inherit;

  text-decoration:
    none;
}

.footer-link:hover {
  color:
    rgb(
      var(--v-theme-primary)
    );
}

@media (
  max-width: 599px
) {
  .footer-inner {
    min-height:
      90px;

    padding:
      16px;

    flex-direction:
      column;

    justify-content:
      center;
  }
}
</style>